// frontend/src/components/CampaignManager/tabs/VermittlerTab.tsx
import React from 'react';
import {
  Box, Button, Stack, Typography, TableContainer, Table, TableHead, TableRow,
  TableCell, TableBody, Paper, IconButton, Chip, useMediaQuery, useTheme
} from '@mui/material';
import { Plus, PencilSimple, Trash } from '@phosphor-icons/react';
import { VermittlerCard } from '../MobileCards';
import { Vermittler } from '../types';

interface Props {
  vermittler: Vermittler[];
  deleteVermittler: (id: number) => Promise<void>;
  onOpenDialog: (vermittler: Vermittler | null) => void;
}

export default function VermittlerTab({ vermittler, deleteVermittler, onOpenDialog }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDelete = async (id: number) => {
    if (window.confirm('Vermittler wirklich löschen?')) {
      await deleteVermittler(id);
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">Vermittler</Typography>
        <Button
          variant="contained"
          size={isMobile ? 'small' : 'medium'}
          startIcon={<Plus size={20} />}
          onClick={() => onOpenDialog(null)}
          sx={{ backgroundColor: '#003366' }}
        >
          {isSmallMobile ? 'Neu' : 'Neuer Vermittler'}
        </Button>
      </Stack>

      {isMobile ? (
        vermittler.length === 0 ? (
          <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">Keine Vermittler vorhanden</Typography>
          </Paper>
        ) : (
          vermittler.map((vm) => (
            <VermittlerCard key={vm.id} vermittler={vm} onEdit={onOpenDialog} onDelete={handleDelete} />
          ))
        )
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Bezeichnung</TableCell>
                <TableCell>Kurzbezeichnung</TableCell>
                <TableCell>Bemerkungen</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Aktionen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vermittler.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                      Keine Vermittler vorhanden
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                vermittler.map((vm) => (
                  <TableRow key={vm.id} hover>
                    <TableCell><strong>{vm.bezeichnung}</strong></TableCell>
                    <TableCell><Chip label={vm.kurz} color="info" size="small" /></TableCell>
                    <TableCell>{vm.bemerkungen || '-'}</TableCell>
                    <TableCell>
                      <Chip label={vm.active ? 'Aktiv' : 'Inaktiv'} color={vm.active ? 'success' : 'default'} size="small" />
                    </TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => onOpenDialog(vm)}>
                        <PencilSimple size={18} />
                      </IconButton>
                      <IconButton size="small" color="error" onClick={() => handleDelete(vm.id)}>
                        <Trash size={18} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
